export const CookieFormType = {
    CATEGORIES: 'categories',
    ACCEPT_ALL_OR_SELECTION: 'accept_all_or_selection',
    ALL: 'all',
};
export const CookieAcceptanceType = {
    DEFAULT: '1',
    ALL: 'all_categories',
    SELECTION: 'selection',
    KNOW_MORE: 'know_more',
};
export const FormField = {
    REFERRER_URL: 'referrer-url',
    ACCEPT_COOKIE: 'accept_cookie',
    DECLINE_COOKIE: 'decline_cookie',
    COOKIE_SETTING: 'cookie_setting[]',
};
export const CookieCategory = {
    FUNCTIONAL: 'functional',
    ANALYTICAL: 'analytical',
    MARKETING: 'marketing',
};
export const AcceptFunctionalCookiesQueryParam = 'accept_functional_cookies';
//# sourceMappingURL=types.js.map